class ReportingEquipmentInfoDetailsController {
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
    }

    $onInit() {
        this.unsubscribe = this.$ngRedux.connect(this.mapState, {})(this);
    }

    $onDestroy() {
        this.unsubscribe();
    }

    mapState(state) {
        return {
            equipment: state.reporting.reportingEquipmentDetails
        }
    }
}

ReportingEquipmentInfoDetailsController.$inject = ['$ngRedux'];

export const reportingEquipmentInfoDetails = {
    controller: ReportingEquipmentInfoDetailsController,
    template: require('./reporting-equipment-info-details.html')
};
